export const apiUrls = {
  // AUTH
  login:  '/auth/login',
  loginRetail: '/auth/costumer-login',
  logout:  '/auth/logout',
  register:  '/auth/register',
  forgotPassword:  '/auth/forgot-password',
  resendEmailConfirmation:  '/auth/resend-email',
  accountActivation:  '/auth/activation/:token',
  resetPassword:  '/auth/reset-password/:token',
  checkEmail:  '/auth/check-email/:email',
  checkCellphone:  '/auth/check-phone/:cellphone',
  tillLogin:  '/auth/till/login',
  tillLogout:  '/auth/till/logout',
  tillPause:  '/auth/till/pause',
  tillRecoverPassword:  '/auth/till/recover-password',
  tradingLogin:  '/auth/till/login',
  tradingLogout:  '/auth/till/logout',
  tradingRecoverPassword:  '/auth/till/recover-password',
  retailRegister: '/auth/till/register',
  retailRewards: '/auth/till/register-rewards',
  tillChangePassword: '/auth/till/change-password',
  getTillWallets:'/auth/wallets/:tillId',

  // CONTENT
  content: '/content',
  settings: '/content/settings/company/:companyId/shop/:shopId',
  provinces: '/content/provinces/:country',
  // EVENTS
  search: '/events/search',
  availableSports: '/events/available-sports',
  searchBetCode: '/events/search-bet-code',
  searchEventCode: '/events/search-event-code',
  searchByCoupon: '/events/search-by-coupon',
  couponList: '/events/coupon-list',
  betCodes: '/events/bet-codes',
  // - SPORT
  serverSentEvent: '/events/:id/stream',
  sportEvents: '/events/sport',
  sportEventsTree: '/events/sport/tree',
  sportEventsList: '/events/sport/list',
  sportEventByCode: '/events/sport/:code',
  // - NUMBER
  numbersBetting: '/events/number',
  numbersBettingTree: '/events/number/tree',
  numberBet: '/events/number/:tournamentCode/id/:eventId',
  popularEvents: '/events/number/popular',
  randomNumber: '/events/number/random/:from/:to/:balls',
  numResults: '/events/number/previousDraws/:tournament',
  numberColours: '/events/number/colours/:tournamentCode',
  // - RACING
  racingEventsList: '/events/racing/list',
  racingEventsTree: '/events/racing/tree',
  racingEventByCode: '/events/racing/:meetingCode/id/:event',
  racingFixedOddsCompetitors: '/events/racing/meeting/:meeting/fixed-odds-competitors',
  racingCrossEvents: '/events/racing/cross-events',
  nextRaces: '/events/racing/next-races',
  getRaceInfo: '/events/racing/event-info/:meeting',
  meetingInfo: '/events/racing/meetingInfo/:meetingCode',
  // USERS
  users: '/users',
  betsHistory: '/users/history/:accountNumber',
  betsHistoryCount: '/users/history/count/:accountNumber',
  userCode: '/users/userCode/:accountNumber',
  userTransactions: '/users/:id/account-statement',
  userLimits: '/users/:id/limits',
  userWallets: '/users/wallets/:accountNumber',
  userRestrictions: '/users/:id/restrictions',
  updateLocale: '/users/:id/:locale',
  validatePassword: '/users/validate-password',
  restrictionReasons : '/users/restriction-reasons',
  // PAYMENTS
  requestWithdrawal: '/payments/request-withdrawal',
  ficaForm: '/payments/fica-form',
  getTransactionTypes:'/payments/transaction-types',
  getTransactionTypeList:'/payments/transaction-type-list',
  transactionDescription:'/payments/transaction-description/:id',
  addTransaction: '/payments/add-transaction',
  getReceipt: '/payments/get-receipt/:ticket',
  ozowDeposit: '/payments/ozow-deposit',
  // BETS
  submitBets: '/bets/submit',
  calculateBets: '/bets/calculate',
  possiblePermutations: '/bets/permutations',
  numberCombinations: '/bets/combinations',
  checkOutcomes: '/bets/check-outcomes/:outcomes',
  registerBet: '/bets/register',
  getBet: '/bets/get-bets/:betId',
  getPlaceBet: '/bets/get-place-bets/:betId',
  // PERIPHERALS
  reader: '/peripherals/reader',
  matrix: '/peripherals/matrix',
  getEmptyCardbyId: '/peripherals/matrix/:id',
  lastMatrix:'/peripherals/last-matrix',
  tillHistory:'/peripherals/till-ta/:tillId',
  tillBalance:'/peripherals/till-balance/:tillId',
  sendTillCommand: '/peripherals/till-command/:tillId',
  getLastTickets: '/peripherals/last-tickets/:till',
  getTicketDetails: '/peripherals/get-ticket/:ticket/:pin',
  assignTicket: '/peripherals/assign-ticket',
  cancelTicket: '/peripherals/cancel-ticket',
  tillTransactions: '/peripherals/till-transactions/:walletId',
  tillOverView: '/peripherals/till-overview/:tillId',
  payoutTicket: '/peripherals/payout',
  scanner: '/peripherals/scanner/:barcode',
  reprint: '/peripherals/reprint',
  lastPayout: '/peripherals/last-payout/:walletId',
  getDenominators: '/peripherals/denominators',
  endShifSession: '/peripherals/endOfShift',
  sessionDetails: '/peripherals/session-details/:sessionId',
  approveShift: '/peripherals/approve-shift/:sessionId',
  transactionTypeHistory: '/peripherals/transaction-types-history/:session',
  adminTillTransactions: '/peripherals/admin-till-transactions',
  cancelRequest: '/peripherals/cancel-request',
  autoTransactions: '/peripherals/get-auto-transactions',
  sessionBalance: '/peripherals/session-balance/:sessionId',
  tillautoTransactions: '/peripherals/till-auto-transactions/:tillId',
  organisationTills: '/peripherals/organisation-tills/:shopId',
  getWallets: '/peripherals/get-wallets/:walletId',
  getAutoTransactions: '/peripherals/get-transactions',
  getRelevantWallets: '/peripherals/get-wallets/:function/:debitParam/:creditParam/:transactionType'
};

export const replaceUrls = (url, obj) => {
  const pattern = /:[\w]+/ig; // :property
  return url.replace(pattern, (token) => obj[token.substr(1)] || '');
};
